<template>
	<div ref="msCbxWithDifferentValue">
		<div class="ms-cell-editor">
			<div
				v-show="!isSelected || readOnly"
				class="flex-center"
				:class="{
					'edit-disabled': readOnly,
					'ms-editor-text': editable,
					'editor-input isValid': cellErrorProvider.isValid,
				}"
			>
				<div class="editor-display">
					<span>{{
						internalDisplay
							| formatData({
								formatType: col.formatType,
								enumName: col.enumName,
								isValueOther: dataRow[col.dataFieldOther],
								value: dataRow[col.dataField],
							})
					}}</span>
				</div>
				<div
					class="icon-input float-right"
					v-tooltip="{
						content: cellErrorProvider.message,
						classes: 'error',
						placement: col.tooltipPlacement,
					}"
					v-if="cellErrorProvider.isValid"
				>
					<div class="mi mi-24 mi-red-tick mr-2"></div>
				</div>
			</div>
			<div
				class="ms-editor w-full h-full"
				ref="editor"
				v-show="isSelected && !readOnly"
			></div>
		</div>
	</div>
</template>
<script>
import msCellInput from './msCellInput';
import msComboboxWithDifferentValue from '@/components/mscombobox/msComboboxWithDifferentValue.vue';
export default {
	name: 'msCellComboboxWithDifferentValue',
	extends: msCellInput,
	created() {
		const me = this;
		me.internalDisplay = me.initField ? me.dataRow[me.initField] : '';
		let col = me.col;
		let props = me.getPropsEditor();
		if (props) {
			let data = props.data;
			if (data && data.length > 0) {
				if (!me.dataRow[col.dataField] && col.initIndex) {
					let item = data[initIndex];
					if (item) {
						me.internalDisplay = item[props.displayField];
						me.$set(me.dataRow, col.dataField, item[props.valueField]);
					}
				} else {
					let item = data.find((_item) => {
						return _item[props.valueField] == me.dataRow[col.dataField];
					});
					if (item) {
						me.internalDisplay = item[props.displayField];
					}
					if (props.forceSelection == false) {
						me.internalDisplay =
							me.internalDisplay || me.dataRow[col.dataField];
						me.$watch(
							() => me.dataRow[col.dataField],
							function (newData, oldData) {
								if (newData || newData === 0) {
									me.internalDisplay = newData;
								}
							}
						);
					}
				}
			}
		}
	},
	data() {
		return {
			initField: null,
			internalDisplay: null,
		};
	},
	computed: {
		getDisplayField() {
			const me = this;
			let editorProperty = me.getEditorProperty();
			if (editorProperty) {
				let props = editorProperty.propsData;
				return props.displayField;
			}
			return null;
		},
	},
	methods: {
		getPropsEditor() {
			const me = this;
			let editorProperty = me.getEditorProperty();
			if (editorProperty) {
				let props = editorProperty.propsData;
				return props;
			}
			return null;
		},
		getEditorControl() {
			return msComboboxWithDifferentValue;
		},
		customEditProperty(editorProperty) {
			const me = this;
			if (editorProperty) {
				let props = editorProperty.propsData;
				if (props.data && typeof props.data == 'function') {
					me.editorDataFunc = props.data;
					props.data = props.data(me.dataRow);
				}
			}
		},
		//Hàm xử lý trước khi edit reset lại các giá trị trong editor cũ
		//Created by LTDAT(17.06.2020)
		beforeEdit(editor) {
			const me = this;
			let dataRow = me.dataRow,
				col = me.col;
			if (editor) {
				if (typeof editor.setValue === 'function') {
					editor.setValue(dataRow[col.dataField], dataRow[col.dataFieldOther]);
				}
				if (typeof editor.setInternalText === 'function') {
					if (
						!dataRow[col.dataFieldOther] &&
						(!col.enumName || editor.forceSelection == false)
					) {
						let selectitem = editor.internalDataSource.find((item) => {
							if (me.internalDisplay == '' && item[editor.valueField] == 0) {
								return (
									item[editor.valueField].toString() ==
									me.internalDisplay.toString()
								);
							}
							return item[editor.valueField] == me.internalDisplay;
						});

						if (selectitem) {
							editor.setInternalText(selectitem[editor.displayField]);
						}
					}
				}
				if (me.editorDataFunc && typeof me.editorDataFunc == 'function') {
					editor.data = me.editorDataFunc(me.dataRow);
				}
				if (editor.applyValidate && typeof editor.applyValidate == 'function') {
					me.$nextTick(() => {
						if (editor.isValueOther && editor.$refs.inputOrther) {
							editor.$refs.inputOrther.validate();
						} else if (me.cellErrorProvider && me.cellErrorProvider.message) {
							editor.applyValidate(me.cellErrorProvider.message);
						}
					});
				}
			}
			me.$emit('rowSelected', me.dataRow);
		},
		//Hàm custom thêm sự kiện cho control
		//Created by LTDAT(18.06.2020)
		addCustomHandler(editor) {
			const me = this;
			editor.$on('selected', (...args) => {
				if (editor.$cell) {
					editor.$cell.selectedHandler(...args);
				}
			});
			editor.$on('loadData', (...args) => {
				if (editor.$cell) {
					editor.$cell.loadData(...args);
				}
			});
			editor.$on('changeText', (...args) => {
				if (editor.$cell) {
					editor.$cell.changeText(...args);
				}
			});
		},
		changeText(payload) {
			const me = this;
			if (!payload) return;
			me.metaData = {
				dataRow: me.dataRow,
				column: me.col,
				cell: me,
				...payload,
			};
			me.internalDisplay = payload.newValue;
			this.$emit('changeCombobox', {
				valueDisplay: me.internalDisplay,
				_editor: me,
				metaData: me.metaData ,
			});
		},
		loadData(payload) {
			const me = this;
			let metaData = {
				dataRow: me.dataRow,
				column: me.col,
				...payload,
			};
			me.$emit('loadDataCombo', metaData);
		},
		directEventSelected() {
			let me = this,
				col = me.col,
				editor = me.col.__editor;
			if (editor) {
				editor.$cell.selectedHandler(...arguments);
			}
		},
		selectedHandler(data) {
			const me = this;
			let col = me.col;
			let metaData = {
				dataRow: me.dataRow,
				column: col,
				...data,
				cell: me,
			};
			me.$emit('selected', metaData);
		},

		focusEditor(editor) {
			const me = this;
			let input = me.$refs.editor.querySelector('#inputOther');
			if (input) {
				setTimeout(() => {
					input.focus();
				}, 100);
			}
		},
	},
	watch: {
		internalDisplay: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
			},
			deep: true,
		},
	},
};
</script>
<style lang="scss" scoped>
.editor-display {
	padding: 6px;
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 50px;
	overflow: hidden;
}
</style>